import axios from "../axios/axios";
import { selectTableItems } from "../store/actions";
import { appSetAlert, appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { apiSetAlert } from "./appApi";
import { errorDispatcher, formatDate, getOptionsQuery } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { setEditItem } from "../store/actions/formAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";
import { Currency } from "lucide-react";

export const apiGetAccountingsExcel = (token, accountingStatus, selectedIds) => (dispatch, getState) => {
  let url = "accountings/excel/export";
  if (selectedIds && selectedIds.length > 0) {
    url += `?ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `accountings_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetAccounting = (accountingId, factorType, token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`accountings/${accountingId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (callback) {
        callback(response.data.accounting);
      } else {
        dispatch(setEditItem(response.data.accounting));
      }
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetAccountings =
  ({ pagination, token, key, sort, search }) =>
    (dispatch, getState) => {
      // let accountingType = typeof key === "string" ? lowerFirst(key.slice(10)) : null;

      let options = getOptionsQuery(pagination, search, sort);

      dispatch(appSetLoading());
      axios
        .post(`/accountings/list`, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response.data.accountings, response.data.paginate));
          // dispatch(setAccountings(response.data.accountings));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiSortAccountings = (token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("/accountings/sort", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSortAccountingCodes = (token, model, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`/sort?modelName=${model}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      dispatch(appSetAlert("شماره گذاری مجدد اسناد با موفقیت انجام شد", "success"));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
const sendRequest = async (fullData, getState, callBack, index) => {
  const token = getState().businessReducer.business?.token;
  for (const ix in fullData) {
    if (ix > index) {
      const row = fullData[ix]
      row["isExcel"] = true
      const res = await axios.post(`/accountings`, row, {
        headers: { Authorization: `Bearer ${token}` },
      }).catch(error => {
        fullData[ix].status = "error"
        fullData[ix].error = error.response.data.message;
      })

      if (res) {
        fullData[ix].status = "saved"
      }

    }
  }
  callBack(fullData)
}
export const apiAddAccountingByExcel = (forms, token, callback) => (dispatch, getState) => {
  const idFilter = []
  const fullData = []
  forms.map((row, ix, data) => {
    const newRow = row.main
    if (idFilter.indexOf(newRow.voucherHeaderId) === -1) {
      idFilter.push(newRow.voucherHeaderId)
      const filterData = data.filter(x => x.main.voucherHeaderId === newRow.voucherHeaderId)
      const neWAcount = { accounting: {}, accountingItems: [] }
      filterData.map(filRoww => {
        const filRow = filRoww.main
        if (Object.keys(neWAcount.accounting).length === 0) {
          neWAcount.accounting = {
            "description": filRow.descriptionHeader,
            "date": filRow.date,
            "ProjectId": filRow.ProjectId,
            "BranchId": filRow.BranchId,
            "reference": filRow.reference
          }
        }
        neWAcount.accountingItems.push({
          "amount": filRow.creditor > 0 ? filRow.creditor : filRow.debtor,
          "description": filRow.description,
          "isCreditor": filRow.creditor > 0,
          "accountTypeId": filRow.accountTypeId,
          "accountTypeCode": filRow.accountTypeCode,
          "detailId": filRow.detailId,
          "detailCode": filRow.detailCode
        })
      })
      fullData.push(neWAcount)

    }

  })
  sendRequest(fullData, getState, callback, -1)
  // for await (const row of fullData) {
  //   console.log(row, "rowwwwwwwwwwwwww")
  // }
}
export const apiSaveAccounting = (accountingForm, token, callback) => (dispatch, getState) => {
  let accountingItems = [];
  accountingForm.items?.map((item) => {
    if (item.accounting) {
      const amount = parseFloat(item.creditor) > 0 ? parseFloat(item.creditor) : parseFloat(item.debtor);
      accountingItems.push({
        amount: Math.abs(amount),
        description: item.description,
        isCreditor: item.creditor > 0,
        accountTypeId: item.accounting.id,
        currency_exchange: accountingForm.isCurrency ? parseFloat(item.currency_exchange) : null,
        detailId: item.accounting?.detail?.id ?? null,
      });
    }
  });

  const accounting = {
    accounting: {
      accountingCode: accountingForm.accountingCodeType ? null : accountingForm.accountingCode ?? null,
      description: accountingForm.description ?? null,
      date: accountingForm.date ? formatDate(accountingForm.date) : null,
      ProjectId: accountingForm.project?.id ?? null,
      BranchId: accountingForm.branch?.id ?? null,
      CurrencyId: accountingForm.isCurrency ? accountingForm.CurrencyId?.id ?? null : null,
      reference: parseInt(accountingForm.reference) ?? null,
    },
    accountingItems,
  };

  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .post(`/accountings`, accounting, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateAccounting =
  (accountingForm, token, accountingId, callback) => (dispatch, getState) => {
    let accountingItems = [];

    accountingForm.items?.map((item) => {
      if (item.accounting) {
        const amount = (item.creditor ?? 0) - (item.debtor ?? 0);
        accountingItems.push({
          amount: Math.abs(amount),
          description: item.description,
          isCreditor: amount > 0,
          accountTypeId: item.accounting.id,
          currency_exchange: accountingForm.isCurrency ? item.currency_exchange : null,
          detailId: item.accounting?.detail?.id ?? null,
        });
      }
    });

    const accounting = {
      accounting: {
        CurrencyId: accountingForm.isCurrency ? accountingForm.CurrencyId?.id ?? null : null,
        accountingCode: accountingForm.accountingCodeType ? null : accountingForm.accountingCode ?? null,
        description: accountingForm.description ?? null,
        date: accountingForm.date ? formatDate(accountingForm.date) : null,
        ProjectId: accountingForm.project?.id ?? null,
        BranchId: accountingForm.branch?.id ?? null,
        reference: parseInt(accountingForm.reference) ?? null,
      },
      accountingItems,
    };

    dispatch(appSetLoading());
    dispatch(appSetSendingRequest());
    axios
      .put(`/accountings/${accountingId}`, accounting, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(apiSetAlert(response.data.message, "success"));
        callback();
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiDeleteAccountings = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  const accountingIds = selectedIds;
  axios
    .delete(`/accountings/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { accountingIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
